import React, { Fragment } from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'

class Openings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  // Map an array of objects.
  // Each object is an opening period. { startAt: Moment, endAt: Moment }.
  // mapOpeningsToMoment = (dailyOpenings, type) => {
  //   if (type) {
  //     return dailyOpenings
  //       .filter(opening => opening[type])
  //       .map(opening => {
  //       // Only the certain type of opening will remain.
  //         const { start, startMin, end, endMin } = opening
  //         const today = moment().startOf('date')
  //         const startAt = today.clone().add(start, 'hours').add(startMin, 'minutes')
  //         const endAt = today.clone().add(end, 'hours').add(endMin, 'minutes')
  //         return { startAt, endAt }
  //       })
  //   } else {
  //     return dailyOpenings.map(opening => {
  //       // Only the certain type of opening will remain.
  //       const { start, startMin, end, endMin } = opening
  //       const today = moment().startOf('date')
  //       const startAt = today.clone().add(start, 'hours').add(startMin, 'minutes')
  //       const endAt = today.clone().add(end, 'hours').add(endMin, 'minutes')
  //       return { startAt, endAt }
  //     })
  //   }
  // }

  // basically is the same function in About.
  // type = 'takeaway' or 'storeDelivery'
  // renderOpenings = (openingsWithSurcharge, type) => {
  //   if (!openingsWithSurcharge) return
  //   const { intl } = this.props
  //   // Intl
  //   const _weekdaysText = [
  //     intl.formatMessage({ id: 'weekdays.sunday' }),
  //     intl.formatMessage({ id: 'weekdays.monday' }),
  //     intl.formatMessage({ id: 'weekdays.tuesday' }),
  //     intl.formatMessage({ id: 'weekdays.wednesday' }),
  //     intl.formatMessage({ id: 'weekdays.thursday' }),
  //     intl.formatMessage({ id: 'weekdays.friday' }),
  //     intl.formatMessage({ id: 'weekdays.saturday' }),
  //   ]
  //   // const _minuteText = intl.formatMessage({ id: 'times.minute' })
  //   // const _toText = intl.formatMessage({ id: 'times.to' })
  //   const _24hr = intl.formatMessage({ id: 'times.24hr' })

  //   return _.map(openingsWithSurcharge, (dailyOpenings, index) => {
  //     if (!dailyOpenings) return null
  //     const openingMoments = this.mapOpeningsToMoment(dailyOpenings, type)

  //     // Find overlapping period and save it in results.
  //     let results = []
  //     if (openingMoments.length === 1) {
  //       results = openingMoments
  //     } else {
  //       const usedIndexs = []
  //       openingMoments.forEach((openingA, indexA) => {
  //         if (usedIndexs.includes(indexA)) return
  //         usedIndexs.push(indexA)

  //         const result = openingA
  //         openingMoments.forEach((openingB, indexB) => {
  //           if (usedIndexs.includes(indexB)) return

  //           // Result is wholly overlaped by B.
  //           const BOverA = moment(result.startAt).isBetween(openingB.startAt, openingB.endAt, undefined, '[]') && moment(result.endAt).isBetween(openingB.startAt, openingB.endAt, undefined, '[]')
  //           // Result's front is overlaped byB.
  //           const BOverAFront = moment(openingB.startAt).isSameOrBefore(result.startAt) && moment(openingB.endAt).isBetween(result.startAt, result.endAt, undefined, '[]')
  //           // Result's end is overlaped by B.
  //           const BoverAEnd = moment(openingB.startAt).isBetween(result.startAt, result.endAt, undefined, '[]') && moment(openingB.endAt).isSameOrAfter(result.endAt)

  //           // Whan the result is overlaped by B, change the value of result and store indexB in usedIndex.
  //           if (BOverA) {
  //             result.startAt = openingB.startAt
  //             result.endAt = openingB.endAt
  //             usedIndexs.push(indexB)
  //           }

  //           if (BOverAFront) {
  //             result.startAt = openingB.startAt
  //             usedIndexs.push(indexB)
  //           }

  //           if (BoverAEnd) {
  //             result.endAt = openingB.endAt
  //             usedIndexs.push(indexB)
  //           }
  //         })
  //         results.push(result)
  //       })
  //     }

  //     // Map the result to string.
  //     const timeStr = results.map(opening => {
  //       const { startAt, endAt } = opening

  //       // opening 24 hours
  //       const opening24hr = startAt.format('HH:mm') === '00:00' && endAt.format('HH:mm') === '00:00'
  //       if (opening24hr) return _24hr

  //       const _startAt = opening.startAt.format('HH:mm')
  //       const _endAt = opening.endAt.format('HH:mm')
  //       // return `${_startAt} ${_toText} ${_endAt}`
  //       return `${_startAt} - ${_endAt}`
  //     }).join('、')

  //     if (timeStr) {
  //       return (
  //         <Fragment key={index}>
  //           <p>{_weekdaysText[index]}</p>
  //           <p>：</p>
  //           <p>{timeStr}</p>
  //         </Fragment>
  //       )
  //     }
  //     return null
  //   })
  // }

  render () {
    const { classes, merchant, type } = this.props
    if (!merchant) return null

    const renderOpenings = (merchant, type) => {
      const openings = merchant && merchant.setting.directoryOpeningTimeText
      const takeawayOpenings = merchant && merchant.setting.directoryTakeawayTimeText
      const deliveryOpenings = merchant && merchant.setting.directoryDeliveryTimeText

      switch (type) {
        case 'takeaway':
          return <p className={classes.openings}>{takeawayOpenings}</p>
        case 'storeDelivery':
          return <p className={classes.openings}>{deliveryOpenings}</p>
        default:
          return <p className={classes.openings}>{openings}</p>
      }
    }

    return (
      // this.renderOpenings(openingsWithSurcharge, type)
      renderOpenings(merchant, type)
    )
  }
}

const styles = {
  openings: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(Openings)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Openings.jsx